<kt-portlet>


  <!-- <kt-portlet-header [sticky]="true" [title]="portletTitle" [class]="'kt-portlet__head--lg'">
    <ng-container ktPortletTools>
      <button mat-raised-button color="primary" (click)="createNew()">{{ 'AddNew' | localize }}</button>
    </ng-container>
  </kt-portlet-header> -->


  <kt-portlet-body>

    <div class="row align-items-center justify-content-center kt-margin-bottom-10-mobile mb-4">
      <!-- <div class="col-md-6 kt-margin-bottom-10-mobile">
				<label>Ad <i class="text-danger">*</i></label>
				<input class="form-control" placeholder="Ad" [(ngModel)]="user && user.name" name="name" #name="ngModel"
					required />
				<mat-error [hidden]="name.valid || name.pristine">
					name is
					<strong>required</strong>
				</mat-error>
			</div> -->
      <div class="col-md-5">

        <!-- Uretilecek urunu bul ve sec     -->

        <!-- input urun arama -->
        <label>POSM Adı <i class="text-danger">*</i></label>
        <input placeholder="POSM Adı" aria-label="POSM" [matAutocomplete]="auto" [formControl]="ctrlProductKeyword"
          [value]="pp" class="form-control border">

        <!-- input clear button -->
        <mat-icon *ngIf="selectedProduct$ |async" class="clear autocomple-clear" matSuffix
            (click)="clearSelectedProduct()">clear</mat-icon>

        <!-- Auto complete combobox dd-->
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFunc"
          (optionSelected)="onProductSelected($event.option.value)">
          <mat-option *ngFor="let product of products$ | async" [value]="product">
            <img style="vertical-align:middle;" aria-hidden
              src="https://stokyonetimv2.transpop.com.tr/productimages/{{product.kod}}.jpg" height="35" width="35" />
            &nbsp;<span>{{ product.name }}</span> | <span>{{ product.kod }}</span>

          </mat-option>
        </mat-autocomplete>

      </div>

      <!-- Urun fotografina iliskin component dinamk olarak buraya yklenir. -->
      <div class="col-md-1 align-self-center">
        <ng-container #templateProductImage></ng-container>
      </div>
    </div>



    <div class="row justify-content-center kt-margin-bottom-10-mobile mb-4">
      <div class="col-md-6">
        <label>Tedarikçi <i class="text-danger">*</i></label>
        <kt-autocomplete-combo #combSupplier [placeHolder]="'Tedarikçi'" 
        [dataSource]="posmProductionDemandProxy.getSuppliers()"
        (onSelectedItem)="onSelectedSupplier()"></kt-autocomplete-combo>
      </div>
    </div>


    <div class="row justify-content-center kt-margin-bottom-10-mobile mb-4">
      <div class="col-md-6">
        <label>Yaklaşık Termin Tarihi <i class="text-danger">*</i></label>
        <div class="input-group date">
          <input mat-input #inputPickerElement [matDatepicker]="picker"
            [(ngModel)]="createParameter.estimatedProductionDate" type="text" class="form-control"
            (focus)="picker.open()" (click)="picker.open()" [placeholder]="'Yaklaşık Teslim Tarihi'">
          <div class="input-group-append">
            <button class="btn btn-success btn-icon" (click)="picker.open()" type="button"><i
                class="la la-calendar"></i></button>
          </div>
        </div>
      </div>
      <mat-datepicker #picker></mat-datepicker>
    </div>


    <div class="row justify-content-center kt-margin-bottom-10-mobile mb-4">
      <div class="col-md-6">
        <label>Üretim Adedi <i class="text-danger">*</i></label>
        <input class="form-control" type="number" min="0" placeholder="Üretim Adedi"
          [(ngModel)]="createParameter.amount">
      </div>
    </div>


    <div class="row justify-content-center kt-margin-bottom-10-mobile mb-4">
      <div class="col-md-6">
        <label>Açıklama <i class="text-danger">*</i></label>
        <textarea class="form-control" placeholder="Açıklama" [(ngModel)]="createParameter.comment"></textarea>
      </div>
    </div>



    <div class="row justify-content-center kt-margin-bottom-10-mobile mb-4">
      <div class="col-md-6 text-right">
        <button class="btn btn-primary" (click)="createNew()">{{ 'Save' | localize }}</button>
      </div>
    </div>



  </kt-portlet-body>
</kt-portlet>